module.exports = __webpack_public_path__ + "img/garden.7ebdae21.svg";